"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValidators = void 0;
const mobx_1 = require("mobx");
const isDefined = (value) => {
    if (value === undefined) {
        return false;
    }
    if (Array.isArray(value) || mobx_1.isObservableArray(value)) {
        return !!value.length;
    }
    return typeof value === 'string' ? !!value.trim() : !!value;
};
exports.FormValidators = {
    required: (value) => !isDefined(value) && 'Value is required',
    hasLowerCase: (str) => /[a-z]/.test(str),
    hasUpperCase: (str) => /[A-Z]/.test(str),
    hasNumber: (str) => /\d/.test(str),
    passwordIsValidFormat: (password) => password.length > 7 &&
        exports.FormValidators.hasLowerCase(password) &&
        exports.FormValidators.hasUpperCase(password) &&
        exports.FormValidators.hasNumber(password),
    emailFormatIsValid: (email) => {
        /* tslint:disable: ter-max-len */
        const regex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        return email.length !== 0 && regex.test(email);
    },
    minDate: new Date(1900, 1, 1),
    maxDate: new Date(2099, 12, 31),
    isDateValid: (date) => (!date || date > exports.FormValidators.maxDate || date < exports.FormValidators.minDate) &&
        'Please provide a valid date',
    isDateRangeValid: (dateRange) => dateRange.startDate.$ &&
        dateRange.endDate.$ &&
        dateRange.startDate.$ > dateRange.endDate.$ &&
        'Start Date should not be after End Date',
    isDateRangeLessThanMaxLength: (maxDays) => (val) => {
        const dayInMillseconds = 1000 * 60 * 60 * 24;
        return ((val === null || val === void 0 ? void 0 : val.from) &&
            val.to &&
            (val.to.getTime() - val.from.getTime()) / dayInMillseconds >= maxDays &&
            `Only ${maxDays} days can be displayed at time`);
    },
    isAlphaNumeric: (str) => /^(\w+,?)*$/.test(str),
    isMatchingRegex: (regexp, entity) => (str) => !regexp.test(str) && `Invalid format for ${entity}`,
    minLength: (minLength) => (str) => str && str.length < minLength ? `Value's min length is ${minLength}` : false,
    maxLength: (maxLength) => (str) => str && str.length > maxLength ? `Value's max length is ${maxLength}` : false,
};
//# sourceMappingURL=form-validators.js.map